import React from 'react';

function SpecificStrategyInfoModal({
  open,
  onClose,
  showCheckbox,
  dismissStrategyPopups,
  onDismissStrategyPopupsChange,
}) {
  if (!open) return null;

  return (
    <div className="oars-info-overlay" onClick={onClose}>
      <div className="oars-info-modal" onClick={(event) => event.stopPropagation()}>
        <button className="oars-info-modal__close" onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="oars-info-modal__tabs">
          <button type="button" className="oars-info-tab oars-info-tab--sq active">
            SQ
          </button>
        </div>

        <div className="oars-info-modal__body">
          <h3><span className="oars-info-chip oars-info-chip--sq">SQ</span> Scaling Questions</h3>
          <p>Scaling questions invite clients to place their importance, confidence, or readiness for change on a numbered scale. A strong question focuses on one dimension, clearly explains what 0 and 10 mean, and follows naturally from what the client has been saying.</p>
          <p>The follow-up is the key move. Asking why the client chose their number rather than a lower one helps them voice their own reasons, ability, or readiness for change. Asking why the number is not higher often does the opposite by inviting the client to explain what is holding them back. Asking what might help the number move upward can also be useful, although drawing out the change talk already present is often the stronger first step.</p>
          <p>In this exercise, you will ask a scaling question, hear the client&apos;s number, and choose a follow-up. AIMIE evaluates the whole sequence while placing the greatest weight on the direction of that follow-up. Importance, confidence, and readiness are all acceptable choices when they fit the visible conversation.</p>
          <p className="oars-info-citation">Miller, W. R., &amp; Rollnick, S. (2023). <em>Motivational interviewing: Helping people change and grow</em> (4th ed.). Guilford Press.</p>
        </div>

        {showCheckbox && (
          <div className="oars-skill-modal__footer">
            <label className="oars-dismiss-label">
              <input
                type="checkbox"
                checked={dismissStrategyPopups}
                onChange={(event) => onDismissStrategyPopupsChange?.(event.target.checked)}
              />
              Don&apos;t show this again
            </label>
            <button type="button" className="oars-modal-begin-btn" onClick={onClose}>
              Begin
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SpecificStrategyInfoModal;
